export default __webpack_public_path__ + "static/media/warning--pedestrians-crossing--g12.d6a9a05d.png";